import { ButtonBase, lighten, Stack, Typography } from '@mui/material';
import { AnalysisSelectionNew } from 'enums';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface TabProps {
  label: string;
  value: AnalysisSelectionNew;
  active: boolean;

  handleActiveTabChange(value: AnalysisSelectionNew): () => void;
}

const Tab: React.FC<TabProps> = ({ label, value, active, handleActiveTabChange }) => {
  const { classes, cx } = useStyles();

  return (
    <ButtonBase className={cx(classes.tab, active ? 'active' : null)} onClick={handleActiveTabChange(value)} disableRipple={true}>
      <Typography className={classes.tabText}>{label}</Typography>
    </ButtonBase>
  );
};

interface Props {
  selectedAnalysis: AnalysisSelectionNew;

  handleSelectedAnalysisChange(newSelection: AnalysisSelectionNew): () => void;
}

const AnalysisTabBar: React.FC<Props> = ({ selectedAnalysis, handleSelectedAnalysisChange }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Stack className={classes.tabContent} direction={'row'} alignItems={'center'} justifyContent={'center'} gap={1}>
      {_.map(AnalysisSelectionNew, (tab) => (
        <Tab key={tab} label={t(tab)} value={tab} active={selectedAnalysis === tab} handleActiveTabChange={handleSelectedAnalysisChange} />
      ))}
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  tabContent: {
    background: '#FFF',
    padding: '8px',
    borderRadius: '8px',
  },
  tab: {
    padding: '4px 8px',
    color: theme.palette.greys.medium,
    border: `2px solid ${theme.palette.greys.light}`,
    borderRadius: '20px',
    flex: 1,
    '&:hover': {
      color: theme.palette.primary.main,
      border: `2px solid ${theme.palette.primary.main}`,
      background: lighten(theme.palette.primary.main, 0.9),
    },
    '&.active': {
      color: theme.palette.primary.main,
      border: `2px solid ${theme.palette.primary.main}`,
    },
  },
  tabText: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 700,
    lineHeight: 1.4,
  },
}));

export default AnalysisTabBar;
